import { render, staticRenderFns } from "./QuestionDialog.vue?vue&type=template&id=6e0df88a&scoped=true&"
import script from "./QuestionDialog.vue?vue&type=script&lang=js&"
export * from "./QuestionDialog.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDialog.vue?vue&type=style&index=0&id=6e0df88a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0df88a",
  null
  
)

export default component.exports